'use strict';

function wrapNamespace(method) {
  return function(sugarNamespace, arg1, arg2) {
    sugarNamespace[method](arg1, arg2);
  };
}

module.exports = wrapNamespace;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/wrapNamespace.js
// module id = 676
// module chunks = 1